import * as React from 'react';

import { SMART_PAYROLL_HOME_URL } from 'store/modules/app/constants';
import { Icon } from '../Icon/Icon';

export const Header = () => (
  <header className="Header">
    <div className="Container">
      <a className="Header-logo" href={SMART_PAYROLL_HOME_URL}>
        <Icon name="ic-logo" />
      </a>
    </div>
  </header>
);
